//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicService from '@/service/public'
export default {
    data() {
        return {
            lpr: '',
            lpr_one_year: ''
        }
    },
    mounted () {
        PublicService.getHouseLoanCalc().then(({ lpr }) => {
            this.lpr = lpr.five_year
            this.lpr_one_year = lpr.one_year
        })
    },
}
